import { Routes } from "react-router-dom"
import { ProtectedRoute } from "./ProtectedRoute"
import { RoleName } from "../features/auth/types"
import OnboardingRequired from "./OnboardingRequired"

type RouteGroupProps = {
  children: React.ReactNode
}

export const RecruiterAdminRoutes = ({ children }: RouteGroupProps) => {
  console.log("RecruiterAdminRoutes rendered")
  return (
    <ProtectedRoute allowedRoles={[RoleName.Admin, RoleName.Recruiter, RoleName.SiteAdmin]}>
      {children}
    </ProtectedRoute>
  )
}

export const RecruiterRoutes = ({ children }: RouteGroupProps) => {
  return (
    <ProtectedRoute
      allowedRoles={[RoleName.Admin, RoleName.Recruiter, RoleName.SiteAdmin]}>
      <OnboardingRequired>
        <Routes>{children}</Routes>
      </OnboardingRequired>
    </ProtectedRoute>
  )
}

export const SiteAdminRoutes = ({ children }: RouteGroupProps) => {
  return (
    <ProtectedRoute allowedRoles={[RoleName.SiteAdmin]}>
      {children}
    </ProtectedRoute>
  )
}

// TeamMember routes - for microlearning/development features
// Only allows TeamMember (role 4), Admin (role 8), and SiteAdmin (role 1)
// Explicitly excludes SimulationUser/Candidates (role 5)
export const TeamMemberRoutes = ({ children }: RouteGroupProps) => {
  return (
    <ProtectedRoute allowedRoles={[RoleName.TeamMember, RoleName.SiteAdmin, RoleName.Admin]}>
      {children}
    </ProtectedRoute>
  )
}
